import { Button, Pagination } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Page from '../../component/Page'
import api from '../../api/api'
import dayjs from 'dayjs'

export default function DiscountSale() {
    const navigate = useNavigate()
    const [data, setData] = useState([])
    const [page, setPage] = React.useState(1);
    const [rowsPerPage, setRowsPerPage] = React.useState(20);
    const getData = async () => {
        const res = await api.get(`customertypes`)
        const data = await res.data.result
        if (res.data.status === true) {
            setData(data)
        }
    }
    useEffect(() => {
        getData()
    }, [])
    return (
        <Page>
            <div class="container-fluid">

                <div class=" d-flex row justify-content-between align-items-baseline">
                    <div class="col-lg-4 col-md-12 text-left ">
                        <label class="title-content mb-4">
                            ส่วนลดการขาย
                        </label>
                    </div>
                    <div class="col-lg-4 col-md-12 text-end px-4">
                        <Button type="button" class="ButtomSearch" onClick={() => navigate(`/setting/discount-sale/add`)}>แก้ไขส่วนลด</Button>
                    </div>

                </div>

                <div class="listData row">
                    <div class="col-md-12 table-responsive-sm pb-3">
                        <table class="table table-borderless table-hover ">
                            <thead>
                                <tr>
                                    <th class="text-center" >ประเภทลูกค้า</th>
                                    <th class="text-center" >จำนวนที่ซื้อ (เงื่อนไขที่ 1)</th>
                                    <th class="text-center">ส่วนลด %</th>
                                    <th class="text-center" >จำนวนที่ซื้อ (เงื่อนไขที่ 2)</th>
                                    <th class="text-center">ส่วนลด %</th>
                                    <th class="text-center">วันที่สร้าง</th>
                                    <th class="text-center">ผู้สร้าง</th>
                                    <th class="text-center">วันที่แก้ไข</th>
                                    <th class="text-center">ผู้แก้ไข</th>

                                </tr>
                            </thead>
                            <tbody class="cp">
                                {data?.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)?.map((x, i) => (
                                    <tr>
                                        <td class="text-center">{x?.TypeName}</td>
                                        <td class="text-center">{parseFloat(x?.DiscountMinimum_1, 10)
                                            .toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                        <td class="text-center">{x?.DiscountPercent_1}</td>
                                        <td class="text-center">{parseFloat(x?.DiscountMinimum_2, 10)
                                            .toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                        <td class="text-center">{x?.DiscountPercent_2}</td>
                                        <td class="text-center">{dayjs(x?.CreateDate).format('DD/MM/BBBB')}</td>
                                        <td class="text-center">{x?.CreateId}</td>
                                        <td class="text-center">{dayjs(x?.ModifiedDate).format('DD/MM/BBBB')}</td>
                                        <td class="text-center">{x?.ModifiedId}</td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-12 text-center mt-4">
                        <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={Math.ceil(data.length / rowsPerPage)} page={page} onChange={(event, value) => setPage(value)} shape="rounded" />

                    </div>
                </div>
            </div>
        </Page >
    )
}
